<template>
  <main class="page-padding page-sidebar roles-page roles-in-project"
        :class="{'roles-page_full': !sidebarOpen}">
    <div class="roles-right"

         :class="{'roles-right_full': !openNavigator}">

      <roles-header @del="emitDel"></roles-header>

      <roles-single :is-mother="false"
                    :del="delRoles"></roles-single>
      <p class="btn-hint name-hint btn-hint_bottom btn-hint-navigator">

      </p>
    </div>
  </main>
</template>

<script>
  import {mapState, mapMutations, mapActions, mapGetters} from 'vuex'

  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";
  import {hideRoles} from "../../mixins/roles/hideRoles";
  import {generateGrid} from "../../mixins/generateGrid";
  import {loaderMixin} from "../../mixins/utils/loaderMixin";
  import {sidebarState} from "../../mixins/utils/sidebarState";
  import {projectsNavigator} from "../../mixins/utils/projectsNavigator";
  import {projectPageMixin} from "../../mixins/projects/projectPageMixin";

  import rolesSingle from '../../components/Pages/Roles/rolesSingle'
  import rolesHeader from '../../components/Pages/Roles/rolesHeader'
  import rolesIcon from '../../components/Svg/users/group'

  export default {
    name: 'rolesInProject',
    mixins: [tokenAndRoute, hideRoles, generateGrid, loaderMixin, sidebarState, projectsNavigator, projectPageMixin],
    components: {
      rolesHeader,
      rolesSingle,
      rolesIcon
    },
    data() {
      return {
        isCheckAllSingle: false,
        checkedRolesSingle: [],
        layoutSingle: [],
        layoutGroups: [],
        delRoles: false,
      }
    },
    computed: {
      ...mapState({
        projects: state => state.projects.allProjects
      }),
      ...mapGetters({
        adminRole: 'auth/adminRole'
      }),
      isMother() {
        return this.$route.name == 'rolesInProject'
      },
      itemName() {
        let name;
        const id = this.$route.params.item;

        for (let project of this.projects) {
          if (!name) {
            findName(project.items);
          };
        };

        return name;

        function findName(arr) {
          findItem(arr);

          function findItem(a) {
            for (let item of a) {
              if (item.id == id) {
                name = item.name;
                break;
              } else {
                findItem(item.items);
              }
            }
          }
        }
      }
    },
    methods: {
      ...mapMutations({
        setFullSidebar: 'sidebar/SET_DASHBOARD',
        setLinkName: 'sidebar/SET_LINK_NAME',
        setRouteName: 'sidebar/SET_ROUTE_NAME',
      }),
      ...mapActions({
        getOwnedRoles: 'roles/getOwnedRoles',
        getUsers: 'roles/getUsers',
      }),
      emitDel() {
        this.delRoles = true;

        setTimeout(() => {
          this.delRoles = false
        }, 100)
      }
    },
    watch: {
      routeItem(val) {
        if (val) {
          this.setRouteName(this.itemName);
        }
      }
    },
    beforeRouteEnter(to, from, next) {
      next(async vm => {
        const token = localStorage.getItem('token');
        if (token) {
          vm.showLoader();
          await vm.getOwnedRoles({token, id: ''});
          await vm.getUsers(token);

          vm.setFullSidebar(false);
          if (vm.isMother) {
            vm.setLinkName('projectRoles');
            vm.setRouteName(vm.projectMother.name);
          } else {
            vm.setLinkName('projectItemRoles');
            vm.setRouteName(vm.itemName);
          }


          vm.hideLoader();
        };

        if (!vm.adminRole) {
          vm.$router.push('/403');
        }
      });
    },
  }
</script>

<style lang="scss" scoped>
.roles-in-project {
  padding-top: 0!important;
  padding-right: 0!important;
  padding-left: 0!important;
}
</style>
